import Vue from 'vue';
import VueRouter from 'vue-router';
import Districts from '../views/Districts.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Districts,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.hash) {
    next({ path: '/' });
  }
  next();
});

export default router;
